import { Box, BoxProps, ColorOptions, IconNew as Icon, Spacer, Text, TextProps } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { FC, Fragment } from 'react'
import { TextStyle } from 'react-native'
import { LinearGradientContainer } from '../../comps/LinearGradient'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'
import { loginStrings } from '../../data/static/strings'
import { Routes } from '../../nav/routes'
import { Colors, isOsMobile, useWindowDimensions } from '../../util/util'
import Footer from './Footer'

interface LoginBgProps {
  isSignup: boolean
}

const LoginBg: FC<LoginBgProps> = (props) => {
  const { children, isSignup = false } = props
  const navigation = useNavigation()
  const viewPortWidth = useWindowDimensions()

  const themedStyle = styles(viewPortWidth)
  const navigateToSignup = () => {
    navigation?.navigate(Routes.SIGNUP, { path: Routes.SIGNUP, isSignUp: true })
  }
  const navigateToLogin = () => {
    navigation.navigate(Routes.LOGIN, { path: Routes.LOGIN, isSignUp: false })
  }

  const isSmallDevice = viewPortWidth < 550
  const iconSize = isSmallDevice ? 32 : 72

  return (
    <LinearGradientContainer>
      <Fragment>
        <Box {...themedStyle.container}>
          <Box {...themedStyle.rowContainerStyle}>
            <Box {...themedStyle.titleContainer}>
              <Box {...themedStyle.iconContainer(iconSize)}>
                <Icon id={'JIO_ICON'} color={Colors.WHITE as ColorOptions} size={iconSize} />
                <Text {...themedStyle.payStyle}>{loginStrings.pay}</Text>
              </Box>
              <Box marginTop={60} display={isSmallDevice ? 'none' : 'flex'} pl={8} width="100%">
                <Text {...themedStyle.title}>{loginStrings.loginMsg}</Text>
              </Box>
            </Box>
            {viewPortWidth >= 620 && <Spacer size={36} direction={'horizontal'} />}
          </Box>
          <Box {...themedStyle.rightContainerStyle}>
            {viewPortWidth >= 620 && <Spacer size={36} direction={'horizontal'} />}
            <Box {...themedStyle.cardContainer}>
              <Box {...themedStyle.card}>{children}</Box>
              <ModBox show={isOsMobile()} {...themedStyle.signUpStyle} paddingBottom={10}>
                <Text {...themedStyle.dontHaveAccStyle}>
                  {isSignup ? loginStrings.alreadyHaveAccnt : loginStrings.dontHaveAcc}
                </Text>
                <Spacer size={8} direction={'horizontal'} />
                <Text
                  {...themedStyle.signUpText}
                  testID="navigateToLogin"
                  onPress={isSignup ? navigateToLogin : navigateToSignup}>
                  {isSignup ? loginStrings.login : loginStrings.signUp}
                </Text>
              </ModBox>
            </Box>
          </Box>
        </Box>
        <Footer footerStyles={themedStyle} hide={isSmallDevice} />
      </Fragment>
    </LinearGradientContainer>
  )
}

export { LoginBg }

const styles = (breakpoint: number): any => {
  let overideContainer: BoxProps = {}
  let overideTitleContainer: BoxProps = {}
  let overideFooterStyle: BoxProps = {}

  const isMobile = breakpoint < 620
  return {
    container: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      alignContent: 'center',
      flexWrap: 'wrap',
      overflow: 'auto',
      marginTop: isMobile ? 16 : 15,
      ...overideContainer,
    } as BoxProps,
    rowContainerStyle: { flexDirection: 'row', alignSelf: isMobile ? 'flex-start' : 'center' } as BoxProps,
    rightContainerStyle: {
      flexDirection: 'row',
      alignSelf: isMobile ? 'flex-start' : 'center',
      paddingBottom: breakpoint >= 942 ? undefined : 16,
    } as BoxProps,
    cardContainer: {
      flexDirection: 'column',
      alignItems: 'center',
      marginEnd: isMobile ? 0 : 28,
      marginTop: isMobile ? undefined : 60,
    } as BoxProps,
    titleContainer: {
      width: isMobile ? 300 : 551,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      alignSelf: 'center',
      ...overideTitleContainer,
    } as BoxProps,
    iconContainer: (iconSize: number) =>
      ({
        flexDirection: 'row',
        alignSelf: isMobile ? 'center' : 'flex-start',
        justifyContent: 'center',
        align: 'center',
        height: iconSize,
      } as BoxProps),
    payStyle: {
      color: 'WHITE',
      fontSize: isMobile ? 18 : 24,
      fontWeight: '600',
      alignSelf: 'center',
      fontFamily: 'jiotype-medium',
    } as TextProps,
    card: {
      backgroundColor: Colors.WHITE,
      alignItems: 'center',
      shadowColor: Colors.GRAY_SHADOW,
      shadowOffset: {
        width: 0,
        height: 10,
      },
      shadowOpacity: 1,
      shadowRadius: 16,
      elevation: 10,
      borderRadius: 16,
      marginBottom: isMobile ? 16 : undefined,
    } as BoxProps,
    title: {
      color: 'WHITE',
      opacity: 0.25,
      fontSize: 56,
      lineHeight: 60,
      fontWeight: 'BLACK',
      textAlign: 'left',
      fontFamily: 'jiotype-black',
      // ...overideTitle,
    } as TextProps,
    signUpStyle: {
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: 32,
      flexDirection: 'row',
    } as BoxProps,
    dontHaveAccStyle: {
      color: Colors.WHITE,
      opacity: 0.5,
      fontSize: 12,
    } as BoxProps,
    footerStyle: {
      flexDirection: 'row',
      justifyContent: isMobile ? 'flex-end' : 'center',
      alignItems: 'center',
      alignSelf: isMobile ? 'center' : 'flex-end',
      flexWrap: 'wrap',
      marginVertical: 8,
      marginEnd: 8,
      opacity: 0.5,
      ...overideFooterStyle,
    } as BoxProps,
    signUpText: {
      color: Colors.WHITE,
      opacity: 1,
      fontSize: 12,
      fontWeight: '400',
    } as TextProps,
    dotStyle: { fontSize: 4, color: Colors.WHITE } as TextStyle,
    linearGradient: {
      flex: 1,
    },
  }
}
